import { forwardRef } from 'react';
import MuiSkeleton from '@mui/material/Skeleton';
import type { SkeletonProps as MuiSkeletonProps } from '@mui/material/Skeleton';

/** Alias direto do MUI: nenhum default de aparência do projeto diverge do componente. */
export type SkeletonProps = MuiSkeletonProps;

/** Placeholder de carregamento do design system: mesmo tipo/ref/estrutura de pasta dos demais átomos. */
export const Skeleton = forwardRef<HTMLSpanElement, SkeletonProps>(function Skeleton(props, ref) {
  return <MuiSkeleton ref={ref} {...props} />;
});
